/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateParameterNameRequestDto
 */
export interface CreateParameterNameRequestDto {
    /**
     * Unique code for the parameter name
     * @type {string}
     * @memberof CreateParameterNameRequestDto
     */
    code: string;
    /**
     * Name of the parameter
     * @type {string}
     * @memberof CreateParameterNameRequestDto
     */
    name: string;
    /**
     * Unit of measurement for the parameter
     * @type {string}
     * @memberof CreateParameterNameRequestDto
     */
    unit: string;
}

/**
 * Check if a given object implements the CreateParameterNameRequestDto interface.
 */
export function instanceOfCreateParameterNameRequestDto(value: object): value is CreateParameterNameRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function CreateParameterNameRequestDtoFromJSON(json: any): CreateParameterNameRequestDto {
    return CreateParameterNameRequestDtoFromJSONTyped(json, false);
}

export function CreateParameterNameRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateParameterNameRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'unit': json['unit'],
    };
}

export function CreateParameterNameRequestDtoToJSON(json: any): CreateParameterNameRequestDto {
    return CreateParameterNameRequestDtoToJSONTyped(json, false);
}

export function CreateParameterNameRequestDtoToJSONTyped(value?: CreateParameterNameRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'unit': value['unit'],
    };
}

